// src/config/seo.ts
export const siteConfig = {
  title: "Newsroom | AI-Powered Stock Research & Market Intelligence",
  titleTemplate: "%s | Newsroom",
  description: "Experience the future of market analysis with AI-powered insights and real-time data. Newsroom delivers intelligent stock research, financial analysis, and investment recommendations.",
  siteUrl: "https://news-room.ca",
  twitterHandle: "@getnewsroom",
  language: "en",
  author: {
    name: "Newsroom",
    url: "https://news-room.ca",
  },
  organization: {
    name: "Newsroom",
    url: "https://news-room.ca",
    logo: "https://news-room.ca/logo.png",
  },
  keywords: [
    "AI stock research", 
    "market intelligence", 
    "financial analysis", 
    "investment insights", 
    "stock market AI", 
    "trading recommendations", 
    "AI market analysis", 
    "financial data",
    "stock screening",
    "market trends",
    "technical analysis",
    "stock research assistant",
    "investment research platform"
  ],
  alternateLanguages: [
    { code: "en", url: "https://news-room.ca" }
  ],
  localBusiness: {
    type: "FinancialService",
    name: "Newsroom",
    description: "AI-powered stock research and market intelligence platform.",
    areaServed: "Global",
    serviceType: "Financial Analysis"
  }
};